import { render, staticRenderFns } from "./VncModal.vue?vue&type=template&id=ef2d779a"
import script from "./VncModal.vue?vue&type=script&lang=js"
export * from "./VncModal.vue?vue&type=script&lang=js"
import style0 from "./VncModal.vue?vue&type=style&index=0&id=ef2d779a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports